import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from './Request';

export class LoginRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('login', params);
  }
}
